import { useCallback, useContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { getIsNodeFile } from 'utils';
import FileDownloadContext from 'providers/FileDownload/FileDownload.context';
import useStartDownloadingFile from './useStartDownloadingFile';

export default function useFileDownload(
  dataRoomId: string,
  baseLevelNodes?: DataRoomNode[],
) {
  const { openDownloadModal } = useContext(FileDownloadContext);

  const startDownloadingFile = useStartDownloadingFile();

  const download = useCallback(
    (nodes: DataRoomNode[]) => {
      if (nodes.length === 1 && getIsNodeFile(nodes[0])) {
        startDownloadingFile(nodes[0]._id);
      } else {
        openDownloadModal(dataRoomId, nodes, baseLevelNodes);
      }
    },
    [dataRoomId, baseLevelNodes, openDownloadModal, startDownloadingFile],
  );

  return { download };
}
